export default {
  userId: (state) => (state.user ? state.user.id : null),
  userName: (state) => (state.user ? state.user.name : ''),
  snackbar: (state) => state.snackbar,
  uploadProgress: (state) => state.uploadProgress,
};
